import {hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar, toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {filler, fragment, hframe, label} from '@xh/hoist/cmp/layout';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {SecurityGridModel} from './SecurityGridModel';
import './SecurityGrid.scss';
import {virtualGrid} from '../../../cmp/virtualGrid/VirtualGrid';
import {textInput} from '@xh/hoist/desktop/cmp/input';
import {fmtNumber} from '@xh/hoist/format';
import {Security} from '../../../data/DataTypes';
import {securityImportDialog} from './import/SecurityImportDialog';
import {securityEditDialog} from './edit/SecurityEditDialog';
import {menuButton} from '@xh/hoist/desktop/cmp/menu';
import {splitProcessor} from './splits/SplitProcessor';
import {retweetIcon, splitIcon} from '../../../../core/Icons';

export const securityGrid = hoistCmp.factory<SecurityGridModel>(({model}) =>
    fragment(
        panel({
            item: hframe(
                virtualGrid<Security>({
                    onModelReady: vGridModel => model.setVGridModel(vGridModel),
                    queryUrl: model.vGridQueryUrl,
                    getRowId: params => params.data.id.toString(),
                    columnDefs: model.vGridColumns,
                    defaultColDef: model.vGridColumnDefaults,
                    ctxMenu: params => model.vGridCtxMenu(params),
                    onRowDoubleClicked: (rowData: Security) => model.onRowDoubleClicked(rowData),
                    persistKey: 'secMasterGrid',
                    showRowBorders: true,
                    stripeRows: true,
                    showHover: true
                })
            ),
            tbar: tbar(),
            mask: model.apiTask
        }),
        securityImportDialog({model: model.importModel}),
        securityEditDialog({model: model.editModel}),
        splitProcessor({model: model.splitProcessor})
    )
);

const tbar = hoistCmp.factory<SecurityGridModel>({
    render({model}) {
        return toolbar(
            button({
                text: 'Add',
                icon: Icon.plus(),
                intent: 'success',
                minimal: false,
                onClick: () => model.add()
            }),
            button({
                text: 'Edit',
                icon: Icon.edit(),
                intent: 'primary',
                disabled: !model.selectedRecord,
                minimal: false,
                onClick: () => model.edit()
            }),
            button({
                text: 'Update',
                icon: retweetIcon(),
                intent: 'primary',
                disabled: !model.selectedRecord,
                minimal: false,
                onClick: () => model.updateExisting()
            }),
            button({
                text: 'Import',
                icon: Icon.cloudDownload(),
                minimal: false,
                onClick: () => model.import()
            }),
            button({
                text: 'Clone',
                icon: Icon.copy(),
                disabled: !model.selectedRecord,
                minimal: false,
                onClick: () => model.clone()
            }),
            button({
                text: 'Delete',
                icon: Icon.delete(),
                intent: 'danger',
                disabled: !model.selectedRecord,
                minimal: false,
                onClick: () => model.delete()
            }),
            toolbarSep(),
            menuButton({
                text: 'Corp Actions',
                icon: Icon.calendar(),
                menuItems: [{text: 'Splits', icon: splitIcon(), actionFn: () => model.openSplits()}]
            }),
            filler(),
            label(fmtNumber(model.vGridModel?.rowCount, {label: ' records'})),
            textInput({
                bind: 'quickFilter',
                commitOnChange: true,
                enableClear: true,
                placeholder: 'Global filter...'
            }),
            button({
                icon: Icon.filterSlash(),
                intent: 'warning',
                onClick: () => model.clearFilters()
            })
        );
    }
});
